import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { FieldType } from "@bpm/models";
import { environment } from "environments/environment";

@Injectable({ providedIn: "root" })
export class FieldTypeService {
  //EndPoint para controlador de este objeto en backend
  private fieldTypeApiEndPoint = `${environment.bpmApiUrl}/api/field-types`;

  constructor(private _http: HttpClient) {}

  //Obtiene todos los FieldType
  getAllFieldTypes() {
    return this._http.get<FieldType[]>(this.fieldTypeApiEndPoint);
  }
}
